import { useState } from "react";
import { Check } from "lucide-react";
import {
  Button,
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@pushpress/pushpress-ui";
import { cn } from "../../../../utils/css";

type ComboboxSelectProps = {
  label: string;
  options: { value: string; label: string; email: string }[];
  value: string;
  onChange: (value: string) => void;
};

export default function ComboboxSelect({
  label,
  options,
  value,
  onChange,
}: ComboboxSelectProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="tw-w-[350px] tw-justify-between"
        >
          {options.find((option) => option.value === value)?.label ||
            `Select ${label}`}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="tw-w-[330px] tw-p-0">
        <Command>
          <CommandInput
            placeholder="Search by name or email"
            className="tw-h-9"
          />
          <CommandList>
            <CommandEmpty>No {label} found.</CommandEmpty>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.value}
                  onSelect={(currentValue) => {
                    onChange(currentValue === value ? "" : currentValue);
                    setOpen(false);
                  }}
                  keywords={[option.label, option.email]}
                >
                  {option.label}
                  <Check
                    className={cn(
                      "ml-auto",
                      value === option.value
                        ? "tw-opacity-100"
                        : "tw-opacity-0",
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
